import Vue from "vue";

import { getCredentials, addCredential, deleteCredential } from "@/api";
//
export default {
  namespaced: true,

  state: {
    credentials: {},
    page: 1,
    limit: 5,
    sort: "-_id",
    loading: true
  },

  mutations: {
    setCredentials(state, credentials) {
      state.credentials = credentials;
    },
    setPage(state, page) {
      state.page = page;
    },
    setSort(state, sort) {
      state.sort = sort;
    },
    setLimit(state, limit) {
      state.limit = limit;
    },
    setLoading(state, loading) {
      state.loading = loading;
    }
  },

  actions: {
    async getCredentials(store, payload = {}) {
      store.commit("setLoading", true);
      const resp = await getCredentials({
        page: store.state.page,
        limit: store.state.limit,
        sort: store.state.sort
      });
      if (resp.data.status) {
        const res = {
          ...resp.data.result,
          docs: resp.data.result.docs.map(doc => {
            return {
              ...doc,
              isNew: doc._id === payload.newId
            };
          })
        };
        store.commit("setCredentials", res);
        store.commit("setLoading", false);
        return resp.data.result;
      }
    },
    async goToPage(store, payload) {
      if (
        payload.page &&
        store.state.credentials.totalPages &&
        store.state.credentials.totalPages >= payload.page
      ) {
        store.commit("setPage", payload.page);
        await store.dispatch("getCredentials");
      }
    },
    async changeSorting(store, payload) {
      if (payload.sort !== undefined) {
        store.commit("setSort", payload.sort);
        await store.dispatch("getCredentials");
      }
    },

    async addCredential(store, credential) {
      const resp = await addCredential(credential);
      if (resp.data.status) {
        await store.dispatch("getCredentials", {
          newId: resp.data.result._id
        });
        return resp;
      }
    },
    async deleteCredential(store, id) {
      const resp = await deleteCredential(id);
      if (resp.data.status) {
        await store.dispatch("getCredentials");
        return resp;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/ledgerCredentials.js